import React from 'react';
import SectionCard from '../controls/SectionCard';
import Row from '../controls/Row';
import NumberInput from '../controls/NumberInput';
import Slider from '../controls/Slider';

const clampRotation = (value) => {
  let next = Number(value);
  if (Number.isNaN(next)) return 0;
  if (next > 180) next -= 360;
  if (next < -180) next += 360;
  return next;
};

const TransformSection = ({ model, disabled }) => {
  const x = model.mixed('x');
  const y = model.mixed('y');
  const w = model.mixed('w');
  const h = model.mixed('h');
  const rotation = model.mixed('rotation');
  const opacity = model.mixed('opacity');

  const minW = model.selectionType === 'text' ? 48 : 20;
  const minH = model.selectionType === 'text' ? 24 : 20;

  return (
    <SectionCard title="Transform">
      <Row label="X">
        <NumberInput
          value={x.value}
          mixed={x.kind === 'mixed'}
          onCommit={(value) => model.applyToSelection({ x: value }, 'debounced', 'transform-x')}
          disabled={disabled}
        />
      </Row>
      <Row label="Y">
        <NumberInput
          value={y.value}
          mixed={y.kind === 'mixed'}
          onCommit={(value) => model.applyToSelection({ y: value }, 'debounced', 'transform-y')}
          disabled={disabled}
        />
      </Row>
      <Row label="W">
        <NumberInput
          value={w.value}
          mixed={w.kind === 'mixed'}
          min={minW}
          onCommit={(value) => model.applyToSelection({ w: Math.max(minW, value) }, 'debounced', 'transform-w')}
          disabled={disabled}
        />
      </Row>
      <Row label="H">
        <NumberInput
          value={h.value}
          mixed={h.kind === 'mixed'}
          min={minH}
          onCommit={(value) => model.applyToSelection({ h: Math.max(minH, value) }, 'debounced', 'transform-h')}
          disabled={disabled}
        />
      </Row>
      <Row label="Rotate">
        <NumberInput
          value={rotation.value}
          mixed={rotation.kind === 'mixed'}
          onCommit={(value) =>
            model.applyToSelection({ rotation: clampRotation(value) }, 'debounced', 'transform-rotation')}
          disabled={disabled}
        />
      </Row>
      <Slider
        label="Rotation"
        min={-180}
        max={180}
        step={1}
        value={rotation.kind === 'mixed' ? 0 : rotation.value || 0}
        mixed={rotation.kind === 'mixed'}
        onChange={(value) => model.applyToSelection({ rotation: clampRotation(value) }, 'commitOnRelease', 'rotation-drag')}
        onCommit={() => model.commitPending('rotation-commit')}
        disabled={disabled}
      />
      <Slider
        label="Opacity"
        min={0}
        max={100}
        step={1}
        value={opacity.kind === 'mixed' ? 100 : Math.round((opacity.value ?? 1) * 100)}
        mixed={opacity.kind === 'mixed'}
        onChange={(value) =>
          model.applyToSelection({ opacity: value / 100 }, 'commitOnRelease', 'opacity-drag')}
        onCommit={() => model.commitPending('opacity-commit')}
        disabled={disabled}
      />
    </SectionCard>
  );
};

export default TransformSection;
